import type MarketSelectionProperties from "../MarketSelection.properties.ts";
import { useMarketSelectionController } from "../MarketSelection.controller.ts";
import type { ChangeEvent } from "react";
import ShopSmartSelectView from "../../menu/shared/ShopSmartSelect.view.tsx";

export default function MarketSelectionMobileView(
  props: MarketSelectionProperties,
) {
  const { handleMarketSelectionChangedMobile, markets } =
    useMarketSelectionController(props);

  return (
    <ShopSmartSelectView
      isMobile
      selectedValue={props.selectedValue}
      marketsData={markets}
      handleChange={(event: ChangeEvent<HTMLSelectElement>) =>
        handleMarketSelectionChangedMobile(event.target.value)
      }
    />
  );
}
